import '../../common/Common';
import React, { Component, PropTypes } from 'react';
import { RootTitle } from '../../PageTitle';
import GameDayRouter from './GameDayRouter';
import Helmet from 'react-helmet';
import ProductionLogo from '../res/FastModel_Logomark_RGB.png';
import DevLogo from '../res/GMD_dev_staging_logo.png';

ga('create', 'UA-22713573-6', 'auto');

export default class GameDay extends Component {
  static contextTypes = {
    config: PropTypes.object,
  };

  isProduction = () => {
    const { config: { SERVLET_URL } } = this.context;
    return SERVLET_URL && !(SERVLET_URL.indexOf('dev') > -1 || SERVLET_URL.indexOf('staging') > -1);
  };

  render() {
    const logo = this.isProduction() ? ProductionLogo : DevLogo;

    const META = [
      // when added to home screen, it should say 'GameDay' regardless of window title
      { name: 'apple-mobile-web-app-title', content: 'GameDay' }
    ];

    const LINK = [
      // Use the FastModel logo for the home icon for now
      { rel: 'apple-touch-icon', href: logo },
      { rel: 'shortcut icon', href: logo }
    ];

    return (
      <div style={{ height: '100%' }}>
        <Helmet meta={META} link={LINK}/>
        <RootTitle baseTitle="GameDay">
          <GameDayRouter/>
        </RootTitle>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/GameDay/components/GameDay.jsx